import React from 'react';
import { useStateContext } from '../../../../context/ContextProvider';
import ColorLandingPage from '../../../LandingPages/ColorLandingPage';

function BinghattiSpectre({
    language
}) {
    const color = "purple";

    const images = [
        "/assets/images/projects/binghatti-spectre/binghatti-spectre-1.jpg",
        "/assets/images/projects/binghatti-spectre/binghatti-spectre-2.jpg",
        "/assets/images/projects/binghatti-spectre/binghatti-spectre-3.jpg",
    ];

    const poster = "/assets/images/projects/binghatti-spectre/binghatti-spectre-2.jpg";
    // const webm = "/assets/images/projects/azizi-venice/hero.webm";
    const video = "/assets/images/projects/binghatti-spectre/binghatti-spectre.mp4";

    const {
        langs,
        langCode,
        userInfo,
        HIKALRE_URL,
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    const isUAE = userInfo?.countryName == "United Arab Emirates";
    const isUSA = userInfo?.countryName == "United States";
    const isCanada = userInfo?.countryName == "Canada";

    const Heading = () => {
        return (
            <>
                {language == "ar" ? (
                    <h1 className="text-center text-xl lg:text-2xl font-bold leading-relaxed">
                        لايفوتكم الفرصة من بن غاطي
                        <br />
                        سجل الحين وهنرسلك كل التفاصيل
                        {/* <span className="text-2xl text-orange-200 neon-orange">
                            وفر أكثر من 77 ألف درهم.. وامتلك شقتك دقائق من مطار آل مكتوم
                        </span>
                        <br /> */}
                    </h1>
                ) : (
                    <h1 className="font-bold text-center text-xl leading-relaxed">

                                Don't miss this opportunity from Binghatti
                                <br />
                                Register now and we'll send you all the details
                        
                        {/* <br />
                        <span className="text-2xl text-orange-200 neon-orange">
                            Save over AED 77,000 and own your apartment just minutes from Al Maktoum International Airport.
                        </span>
                        <br />
                        Reserve your unit with just a 10% down payment. */}

                    </h1>
                )}

            </>
        );
    }

    const gridDetails = [
        {
            "topic": "أنواع الوحدات",
            "text": "استوديو 3,2,1 غرفة",
        },
        {
            "topic": "الأسعار تبدأ من",
            "text": isUAE ? "655,000 درهم" : "180 ألف دولار",
        },
        {
            "topic": "أقساط شهرية",
            "text": isUAE ? "6600 درهم" : "1800 دولار",
        },
    ];

    const imageDetails = {
        "title": "✨ عرض حصري لفترة محدودة ✨",
        "desc": "احجز وحدتك الآن واستمتع بمطبخ مجهز بالكامل بجميع الأجهزة الكهربائية من ماركة Siemens الألمانية"
    };

    return (
        <>
            <ColorLandingPage
                color={color}
                // language={language}
                langToggle={{
                    en: "/binghatti/spectre",
                    ar: "/binghatti/spectre/ar",
                }}
                poster={poster}
                video={video}
                images={images}
                heading={<Heading />}
                // gridDetails={gridDetails}
                // imageDetails={imageDetails}
                displayAmenity={false}
                displayVisa={false}
                base_url={HIKALRE_URL}
                projectName={"Spectre"}
                developer="Binghatti"
                project="Spectre"
                leadType="Apartment"
                language={language === "ar" ? "Arabic" : "English"}
                // enquiries={["Studio", "1 Bedroom", "2 Bedrooms", "Retail", "Offices"]}
                enquiries={
                    language == "ar"
                        ? [
                            { label: "استوديو", enquiryType: "Studio", leadType: "Apartment" },
                            { label: "غرفة وصالة", enquiryType: "1 Bedroom", leadType: "Apartment" },
                            { label: "غرفتين وصالة", enquiryType: "2 Bedrooms", leadType: "Apartment" },
                            { label: "ثلاث غرف نوم", enquiryType: "3 Bedrooms", leadType: "Apartment" },
                            { label: "محل تجاري", enquiryType: "Retail", leadType: "Comercial" },
                            { label: "مكاتب", enquiryType: "Offices", leadType: "Comercial" },
                        ]
                        : [
                            { label: "Studio", enquiryType: "Studio", leadType: "Apartment" },
                            { label: "1 Bedroom", enquiryType: "1 Bedroom", leadType: "Apartment" },
                            { label: "2 Bedrooms", enquiryType: "2 Bedrooms", leadType: "Apartment" },
                            { label: "3 Bedrooms", enquiryType: "3 Bedrooms", leadType: "Apartment" },
                            { label: "Retail", enquiryType: "Retail", leadType: "Comercial" },
                            { label: "Offices", enquiryType: "Offices", leadType: "Comercial" },
                        ]
                }
                // assignedToManager={language == "fa" ? 120 : null}
                // assignedToSales={language == "fa" ? 518 : null}
                contactTime={isUSA || isCanada ? true : false}
                otpCode={101}
            />
        </>
    );
}

export default BinghattiSpectre;
